module.exports = ".sheet-container{position:fixed;padding:10px;left:0;top:0;right:0;margin-top:70px;z-index:10}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/ui/sheet/sheet.component.scss
// module id = 269
// module chunks = 0